export const tabs = [
  { id: 'register', label: 'Register', count: 7 },
  { id: 'obligations', label: 'Outstanding obligations' },
  { id: 'department-scores', label: 'Department scores' }
];

export const register_cards = [
  { label: 'Employees', value: '7', note: 'Under monitoring', accent: 'slate' },
  { label: 'Compliant', value: '3', note: '43%', accent: 'green' },
  { label: 'Action required', value: '3', note: 'Outstanding items', accent: 'orange' },
  { label: 'In revalidation', value: '1', note: 'Back in OnboardOS', accent: 'red' }
];

export const employee_filters = [
  { id: 'all', label: 'All', active: true },
  { id: 'finance', label: 'Finance' },
  { id: 'operations', label: 'Operations' },
  { id: 'it', label: 'IT' },
  { id: 'marketing', label: 'Marketing' }
];

export const employee_departments = [
  'Finance',
  'Procurement',
  'IT',
  'IT Security',
  'Operations',
  'HR',
  'Marketing',
  'Legal'
];

export const employee_statuses = ['Compliant', 'Action required', 'Revalidation'];

export const employee_rows = [
  { ref: 'E-204', employee: 'Sarah Khumalo', role: 'Junior Analyst', dept: 'Finance', compliance: 27, outstanding: 'Ack: POPIA / data protection, Ack: Procurement policy +6', status: { label: 'Action required', class: 'bg-warning-subtle text-warning-emphasis' }, accent: '#c1261a' },
  { ref: 'E-101', employee: 'John Moyo', role: 'Finance Manager', dept: 'Finance', compliance: 100, outstanding: 'No open items', status: { label: 'Compliant', class: 'bg-success-subtle text-success-emphasis' }, accent: '#13856f' },
  { ref: 'E-156', employee: 'Aisha Naidoo', role: 'Operations Lead', dept: 'Operations', compliance: 75, outstanding: 'Ack: Information security, Access review: Operations portal', status: { label: 'Action required', class: 'bg-warning-subtle text-warning-emphasis' }, accent: '#c75a06' },
  { ref: 'E-088', employee: 'Thabo Nkosi', role: 'Procurement Officer', dept: 'Procurement', compliance: 100, outstanding: 'No open items', status: { label: 'Compliant', class: 'bg-success-subtle text-success-emphasis' }, accent: '#13856f' },
  { ref: 'E-042', employee: 'Lerato Botha', role: 'HR Business Partner', dept: 'HR', compliance: 100, outstanding: 'No open items', status: { label: 'Compliant', class: 'bg-success-subtle text-success-emphasis' }, accent: '#13856f' },
  { ref: 'E-219', employee: 'Kabelo Tau', role: 'Senior Engineer', dept: 'IT', compliance: 60, outstanding: 'Ack: Acceptable use, Training: Privileged access +2', status: { label: 'Revalidation', class: 'bg-danger-subtle text-danger-emphasis' }, accent: '#c1261a' },
  { ref: 'E-175', employee: 'Nomsa Dube', role: 'Marketing Specialist', dept: 'Marketing', compliance: 33, outstanding: 'Ack: POPIA / data protection, Training: POPIA awareness +2', status: { label: 'Action required', class: 'bg-warning-subtle text-warning-emphasis' }, accent: '#c1261a' }
];

export const outstanding_sections = [
  {
    title: 'Training outstanding',
    count: '4 outstanding',
    badge: '4 due',
    rows: [
      { employee_ref: 'E-204', icon: 'bi-mortarboard', name: 'Sarah Khumalo - Finance', detail: 'Cybersecurity awareness - due 17 May 2026' },
      { employee_ref: 'E-204', icon: 'bi-mortarboard', name: 'Sarah Khumalo - Finance', detail: 'POPIA awareness - due 30 Jun 2026' },
      { employee_ref: 'E-219', icon: 'bi-mortarboard', name: 'Kabelo Tau - IT', detail: 'Privileged access - due 31 May 2026' },
      { employee_ref: 'E-175', icon: 'bi-mortarboard', name: 'Nomsa Dube - Marketing', detail: 'POPIA awareness - due 30 Jun 2026' }
    ]
  },
  {
    title: 'Policy acknowledgements outstanding',
    count: '5 outstanding',
    badge: '5 due',
    rows: [
      { employee_ref: 'E-204', icon: 'bi-file-earmark-text', name: 'Sarah Khumalo - Finance', detail: 'POPIA / data protection' },
      { employee_ref: 'E-204', icon: 'bi-file-earmark-text', name: 'Sarah Khumalo - Finance', detail: 'Procurement policy' },
      { employee_ref: 'E-156', icon: 'bi-file-earmark-text', name: 'Aisha Naidoo - Operations', detail: 'Information security' },
      { employee_ref: 'E-219', icon: 'bi-file-earmark-text', name: 'Kabelo Tau - IT', detail: 'Acceptable use' },
      { employee_ref: 'E-175', icon: 'bi-file-earmark-text', name: 'Nomsa Dube - Marketing', detail: 'POPIA / data protection' }
    ]
  },
  {
    title: 'Declarations outstanding',
    count: '2 outstanding',
    badge: '2 due',
    rows: [
      { employee_ref: 'E-204', icon: 'bi-people', name: 'Sarah Khumalo - Finance', detail: 'Conflict / annual declaration' },
      { employee_ref: 'E-175', icon: 'bi-people', name: 'Nomsa Dube - Marketing', detail: 'Conflict / annual declaration' }
    ]
  },
  {
    title: 'Access reviews due',
    count: '3 outstanding',
    badge: '3 due',
    rows: [
      { employee_ref: 'E-204', icon: 'bi-lock', name: 'Sarah Khumalo - Finance', detail: 'Finance ERP' },
      { employee_ref: 'E-156', icon: 'bi-lock', name: 'Aisha Naidoo - Operations', detail: 'Operations portal' },
      { employee_ref: 'E-219', icon: 'bi-lock', name: 'Kabelo Tau - IT', detail: 'Production (root)' }
    ]
  },
  {
    title: 'Fit-and-proper renewals',
    count: '2 outstanding',
    badge: '2 due',
    rows: [
      { employee_ref: 'E-204', icon: 'bi-shield-check', name: 'Sarah Khumalo - Finance', detail: 'Vetting renewal required for role' },
      { employee_ref: 'E-219', icon: 'bi-shield-check', name: 'Kabelo Tau - IT', detail: 'Vetting renewal required for role' }
    ]
  }
];

export const department_cards = [
  {
    dept: 'Finance',
    staff: 2,
    note: '1 need action',
    accent: 'red',
    value: '64%',
    bar: 64,
    people: [
      { employee_ref: 'E-204', name: 'Sarah Khumalo', score: 27, color: '#c1261a' },
      { employee_ref: 'E-101', name: 'John Moyo', score: 100, color: '#13856f' }
    ]
  },
  {
    dept: 'Operations',
    staff: 1,
    note: '1 need action',
    accent: 'orange',
    value: '75%',
    bar: 75,
    people: [
      { employee_ref: 'E-156', name: 'Aisha Naidoo', score: 75, color: '#c75a06' }
    ]
  },
  {
    dept: 'Procurement',
    staff: 1,
    note: '',
    accent: 'green',
    value: '100%',
    bar: 100,
    people: [
      { employee_ref: 'E-088', name: 'Thabo Nkosi', score: 100, color: '#13856f' }
    ]
  },
  {
    dept: 'HR',
    staff: 1,
    note: '',
    accent: 'green',
    value: '100%',
    bar: 100,
    people: [
      { employee_ref: 'E-042', name: 'Lerato Botha', score: 100, color: '#13856f' }
    ]
  },
  {
    dept: 'IT',
    staff: 1,
    note: '1 need action',
    accent: 'red',
    value: '60%',
    bar: 60,
    people: [
      { employee_ref: 'E-219', name: 'Kabelo Tau', score: 60, color: '#c1261a' }
    ]
  },
  {
    dept: 'Marketing',
    staff: 1,
    note: '1 need action',
    accent: 'red',
    value: '33%',
    bar: 33,
    people: [
      { employee_ref: 'E-175', name: 'Nomsa Dube', score: 33, color: '#c1261a' }
    ]
  }
];

export function item(title, subtitle = '', state = '', tone = 'neutral') {
  const result_set = { 
    title, subtitle, state, tone 
  };
  return result_set;
}
